import { constNull, pipe } from "fp-ts/function";
import { Option } from "fp-ts/Option";
import { NonEmptyString } from "io-ts-types/lib/NonEmptyString";
import * as remoteData from "../../RemoteData";
import { useQuery } from "../../useAPI";
import {
  DocumentUploadDialog,
  DocumentUploadDialogProps,
} from "../../Common/Dialogs/DocumentUploadDialog/DocumentUploadDialog";
import * as api from "./api";
import { UploadDocumentFlowType } from "../../globalDomain";

type Props = {
  docTypeId: NonEmptyString;
  applicationElementID: Option<NonEmptyString>;
  productType: Option<UploadDocumentFlowType>;
} & Omit<DocumentUploadDialogProps, "mobileUploadEnabled" | "docTypeId">;

export const StandardLoanDocumentUploadDialog = (props: Props) => {
  const [checkDisplaySmsLinkOption] = useQuery(api.checkDisplaySmsLinkOption, {
    documentTypeId: props.docTypeId,
  });

  return pipe(
    checkDisplaySmsLinkOption,
    remoteData.fold(constNull, constNull, ({ displaySmsLinkOption }) => (
      <DocumentUploadDialog
        {...props}
        mobileUploadEnabled={displaySmsLinkOption}
      />
    ))
  );
};
